export const BODY_SCROLL_BAR_CLASSNAME = 'no-scrollbar'
export const WELCOME_SCREEN_KEY = 'yolda-carrier-welcome-screen'

class UiHelper {
  toggleBodyScroll() {
    const body: HTMLBodyElement = document.querySelector('body') as HTMLBodyElement
    const hasNoScrollClassName = body.getAttribute('class')?.includes?.(BODY_SCROLL_BAR_CLASSNAME)

    if (hasNoScrollClassName) {
      return body?.classList?.remove(BODY_SCROLL_BAR_CLASSNAME)
    }

    body?.classList?.add(BODY_SCROLL_BAR_CLASSNAME)
  }

  saveVisitingInfo() {
    window.localStorage.setItem(WELCOME_SCREEN_KEY, 'true')
  }

  scrollToBottom() {
    window?.scrollTo?.({ left: 0, top: document.body.scrollHeight, behavior: 'smooth' })
  }
}

export default new UiHelper()
